<template>
    <b-modal
        v-model="isOpen"
        modal-class="vue-need-bootstrap"
        title-class="font-weight-bold"
        no-close-on-esc
        no-close-on-backdrop
        :scrollable="scrollable"
        centered
        ok-only
        :dialog-class="dialogClass"
        :hide-backdrop="hideBackdrop"
        :hide-header-close="hideClose"
        :ok-title="okTitle"
        :ok-disabled="okDisabled"
        :no-enforce-focus="!autoFocus"
        :title="title"
        :size="size"
        @ok="emit('ok')"
        @close="emit('closed')"
        :hide-footer="hideFooter"
    >
        <slot />
        <!-- override slots for cases where custom renders are needed -->
        <template v-for="(_, slotName) of slots" v-slot:[slotName]="scope">
            <slot :name="slotName" v-bind="scope" />
        </template>
    </b-modal>
</template>

<script lang="ts" setup>
/**
 * Bootstrap Vanilla component doesn't work properly in angular views, so we made a wrapper
 * component for bootstrap-vue modal in order to change only this component
 * after upgrade to vue 3 and remove bootstrap-vue
 */
import { computed, useSlots } from 'vue';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
    (event: 'ok'): void;
    (event: 'closed'): void;
}>();

const slots = useSlots();

const props = withDefaults(
    defineProps<{
        value: boolean;
        size?: string;
        title?: string;
        autoFocus?: boolean;
        okTitle?: string;
        okDisabled?: boolean;
        hideClose?: boolean;
        hideFooter?: boolean;
        scrollable?: boolean;
        hideBackdrop?: boolean;
        dialogClass?: string;
    }>(),
    {
        size: 'md',
        autoFocus: false,
        okTitle: 'Ok',
        okDisabled: false,
        hideFooter: false,
        scrollable: true
    }
);

const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});
</script>
